
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11668',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11668",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.450",
  "dashboard-client-types": "static-1.258",
  "data-fetching-client": "static-1.9514",
  "foundations-components": "static-1.7595",
  "foundations-components-legacy": "static-1.620",
  "foundations-theming": "static-1.4247",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7843",
  "hub-http-shared-msw-handlers": "static-1.9562",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11278",
  "I18n": "static-7.1580",
  "jasmine-runner": "static-1.6306",
  "marketplace-storefront-base": "static-1.11728",
  "quartz": "static-1.6780",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16487",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2700",
  "reporting-testing-lib": "static-1.8606",
  "settings-ui-lib": "static-1.12360",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6800",
  "ui-addon-i18n": "static-1.10981",
  "ui-addon-react-router-dom": "static-1.9382",
  "unified-auth": "static-1.266",
  "unified-auth-core-lib": "static-1.547",
  "usage-tracker": "static-1.7172",
  "usage-tracker-core": "static-1.7022",
  "customer-data-property-utils": "static-1.7916",
  "history": "static-4.47",
  "hub-http": "static-1.6054",
  "integrations-lib": "static-1.15550",
  "marketplace-ui-common": "static-1.19051",
  "property-management-iframe": "static-1.12486",
  "quartz-config": "static-1.558",
  "quartz-core": "static-1.5999",
  "quartz-routing": "static-1.210",
  "quick-fetch": "static-1.3773",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4474",
  "ts-schema": "static-1.3941",
  "ui-universal-auth": "static-1.8752",
  "UIComponents": "static-3.8225",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3265",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3057",
  "quartz-webpack": "static-1.3004",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3864",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4676",
  "foundations-theming-specialty": "static-1.1963",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9263",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5210",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1312",
  "ui-fonts": "static-1.540",
  "ui-images": "static-2.1106",
  "bend-plugin-foundations-theming": "static-1.2730",
  "foundations-theming-base": "static-1.3232",
  "stylex": "static-1.28",
  "HeadJS": "static-2.718",
  "hs-test-utils-bend-plugin": "static-1.2954",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4163",
  "ai-components-ui-library": "static-1.8454",
  "ai-rendering-library": "static-1.9416",
  "chirp-fetch": "static-1.1719",
  "connections-embed-lib": "static-1.691",
  "copilot-toolkit": "static-1.10627",
  "laboratory-lib": "static-3.6996",
  "marketplace-embed": "static-1.21569",
  "marketplace-ui-details": "static-1.8947",
  "marketplace-ui-reviews": "static-1.19007",
  "marketplace-ui-tracking": "static-1.13222",
  "sanitize-text": "static-1.7982",
  "ui-addon-video-player": "static-1.8533",
  "usage-tracker-multi": "static-1.5586",
  "usage-tracker-session-replay": "static-1.4858",
  "wootric-nps": "static-1.6821",
  "apollo-link-hub-http": "static-2.4488",
  "immer": "static-1.33",
  "immerable": "static-1.3991",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66673",
  "cssUtils": "static-1.744",
  "flux-actions": "static-1.311",
  "HubStyle": "static-2.11586",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10048",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10210",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7162",
  "icons": "static-2.626",
  "marketplace-ui-apps-core": "static-1.17584",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4357",
  "foundations-components-test-utils": "static-1.5078",
  "quartz-i18n": "static-1.455",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3567",
  "customer-data-objects": "static-1.7485",
  "property-translator": "static-1.5245",
  "frontend-preferences-client": "static-1.7761",
  "hs-promise-utils": "static-1.5430",
  "hubspot-apollo-client": "static-1.4716",
  "integrations-error-boundary-lib": "static-1.12965",
  "integrations-tracking-lib": "static-1.5425",
  "native-integrations-shared-strings": "static-1.7624",
  "reselect": "static-2.16",
  "sanitize": "static-1.4311",
  "superstore": "static-1.4606",
  "ui-shepherd-react": "static-3.9983",
  "ai-settings-ui-library": "static-1.7558",
  "hub-http-janus": "static-1.803",
  "hubspotter-http": "static-1.4514",
  "immutable-less": "static-1.4491",
  "marketplace-ui-client-types": "static-1.16458",
  "nav-meta": "static-1.29036",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10077",
  "ui-addon-upgrades": "static-9.17707",
  "inbound-db-properties-service-client": "static-1.3710",
  "property-management-common": "static-1.4773",
  "ui-addon-iframeable": "static-1.8884",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.491",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.455",
  "quartz-head": "static-1.445",
  "quartz-test": "static-1.455",
  "quartz-tracking": "static-1.159",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2982",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20482",
  "ContentUtils": "static-1.67730",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2327",
  "customer-data-filters-ui": "static-1.39040",
  "customer-data-objects-ui-components": "static-1.12848",
  "customer-data-reference-ui-components": "static-1.12984",
  "embedded-academy-lib": "static-1.13682",
  "ExportDialog": "static-6.10224",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40750",
  "reporting-snowflake": "static-1.55291",
  "reporting-ui-components": "static-2.63944",
  "reporting-visualizations": "static-1.58749",
  "ui-addon-teams": "static-1.21288",
  "magpie-lib": "static-1.5431",
  "magpie-types": "static-1.4891",
  "simple-logging-lib": "static-1.2887",
  "navigation-components": "static-1.17399",
  "ai-studio-lib": "static-1.11097",
  "developer-experience-shared-components": "static-1.10330",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7829",
  "ui-tool-access": "static-1.9981",
  "usage-based-billing-components-lib": "static-1.8109",
  "usage-tracker-anonymous": "static-1.5589",
  "usage-tracker-public": "static-1.6983",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3456",
  "persist-promise": "static-1.3545",
  "reference-resolvers": "static-1.7999",
  "ui-extensibility-client-types": "static-1.3781",
  "hubspot-apollo-cache": "static-1.175",
  "universal-page-editor-lib": "static-1.2835",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2285",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4907",
  "purchase-motions-components": "static-1.5525",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1388",
  "crm-component-utils": "static-1.38570",
  "crm-properties-common-lib": "static-1.5709",
  "customer-data-properties": "static-1.50874",
  "framework-data-schema-resolvers": "static-1.6709",
  "reference-resolvers-lite": "static-1.7923",
  "navigation-messaging": "static-1.6726",
  "hubspotter-http-shared-msw-handlers": "static-1.9560",
  "cms-field-types": "static-1.4644",
  "content-icons-ui": "static-1.2167",
  "conversations-skeleton-state": "static-1.7085",
  "crm-message-bus": "static-1.42475",
  "customer-data-filters-ui-msw-helpers": "static-1.21475",
  "customer-data-ui-utilities": "static-1.9661",
  "FormUrlGenerator": "static-2.4558",
  "framework-builder-read-service-client": "static-1.3869",
  "framework-data-schema-quick-fetch": "static-1.6614",
  "multi-account-reference-resolvers": "static-1.810",
  "onboarding-tours": "static-1.16315",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13168",
  "academy-common-lib": "static-1.13142",
  "content-assistance-lib": "static-1.7503",
  "dashboard-lib": "static-1.80776",
  "file-manager-components": "static-1.23006",
  "getting-started-shared-tasks": "static-1.17987",
  "hubspot-prosemirror": "static-1.17704",
  "hubspot-prosemirror-plugins": "static-1.17696",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19534",
  "share-with-third-party-component-lib": "static-1.8530",
  "ui-addon-draggable": "static-3.4603",
  "ui-asset-management-lib": "static-1.10756",
  "ui-business-units-lib": "static-1.8868",
  "user-context": "static-1.4936",
  "growth-payments-core": "static-1.24833",
  "reporting-plugins": "static-1.10022",
  "reporting-reports": "static-1.66351",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.562",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28938",
  "react-codemirror": "static-1.10463",
  "apps-service-types": "static-1.3714",
  "oauth-service-types": "static-1.4084",
  "onboarding-scopes": "static-1.6300",
  "onboarding-tours-client": "static-1.4529",
  "platform-infra-nav-components": "static-1.7527",
  "subscription-experience-data-types": "static-1.14627",
  "crm-record-cards-service-types": "static-1.3479",
  "location-customization-utils-lib": "static-1.8678",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4336",
  "nav-client-types": "static-1.2194",
  "purchase-motions-api": "static-1.5528",
  "signup-constants": "static-1.18498",
  "signup-ui-url-generator": "static-2.7871",
  "trials-service-types": "static-1.3737",
  "card-properties-lib": "static-1.43632",
  "commerce-subscription-lib": "static-1.36565",
  "crm-actions": "static-1.6142",
  "crm-cards-data": "static-1.1295",
  "crm-cards-sdk": "static-1.43033",
  "customer-data-properties-shared-msw-handlers": "static-1.8889",
  "customer-data-tracking": "static-1.6719",
  "calling-global-api": "static-1.63803",
  "calling-internal-common": "static-1.31132",
  "calling-lifecycle-internal": "static-1.65185",
  "calling-lifecycle-messages": "static-1.57479",
  "commerce-products-lib": "static-1.8958",
  "conditional-properties-service-client": "static-1.3659",
  "crm-links": "static-1.6103",
  "external-options-client-types": "static-1.4020",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.517",
  "inbounddb-objects-service-types": "static-1.4083",
  "meetings-icalendar-utils-lib": "static-1.469",
  "multi-currency-client-types": "static-1.3552",
  "object-builder-ui-client": "static-1.48124",
  "pipeline-validation-client-types": "static-1.3825",
  "property-value-citations": "static-1.1488",
  "pulse": "static-1.353",
  "smart-property-lib": "static-1.6084",
  "tiered-pricing": "static-1.881",
  "ui-addon-form-validation": "static-1.10830",
  "crm-pipelines-api-client-types": "static-1.4001",
  "react-dnd-compat": "static-1.4457",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5195",
  "growth-onboarding-confetti": "static-1.2909",
  "growth-onboarding-next-action-utils": "static-1.1392",
  "onboarding-tours-utils": "static-1.381",
  "ui-shepherd-tracker": "static-1.7364",
  "academy-service-client": "static-1.3517",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28044",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8222",
  "video-components-external": "static-1.10680",
  "video-data-lib": "static-1.34338",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8404",
  "payment-link-components": "static-1.23040",
  "ui-addon-emoji-picker": "static-1.9724",
  "EmailSignatureEditor": "static-1.23979",
  "viral-links-lib": "static-1.6875",
  "data-token-picker": "static-1.16106",
  "FileManagerLib": "static-1.38646",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5081",
  "getting-started-shared-tasks-store": "static-1.17105",
  "campaign-roi-lib": "static-1.8396",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.229",
  "eligibility-engine-service-types": "static-1.3018",
  "crm_data": "static-4.91365",
  "customer-data-sidebar": "static-2.45515",
  "enrichment-properties-lib": "static-1.15202",
  "commerce-billing-lib": "static-1.18597",
  "commerce-shared-components-lib": "static-1.18045",
  "commerce-tools-ui-lib": "static-1.9888",
  "crm-fe-perf": "static-1.22742",
  "calling-error-reporting": "static-1.31138",
  "shared-worker-versioning": "static-1.10876",
  "calling-usage-tracker": "static-1.6378",
  "voice-sms-access-library": "static-1.355",
  "commerce-permissions": "static-1.598",
  "products-iframe-lib": "static-1.7430",
  "products-ui-components-shared-msw-handlers": "static-1.9944",
  "directed-graph": "static-1.776",
  "event-emitter": "static-1.784",
  "breeze-intelligence-kit": "static-1.5376",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9645",
  "policy-lib": "static-1.6614",
  "react-tinymce": "static-1.54721",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9708",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53847",
  "tinymce-plugins": "static-1.56961",
  "tinymce-themes": "static-1.55817",
  "growth-onboarding-next-action-components": "static-1.1420",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6418",
  "content-media-composition-data-lib": "static-1.11586",
  "content-media-compositions": "static-2.15593",
  "media-bridge-lib": "static-1.18628",
  "commerce-tours-lib": "static-1.5771",
  "growth-onboarding-reliability": "static-1.4923",
  "sales-checkout-service-client": "static-1.3504",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21371",
  "sales-email-signature-service-client": "static-1.3680",
  "audio-components": "static-1.5666",
  "FileManagerCore": "static-1.38505",
  "FileManagerImages": "static-1.36157",
  "video-components": "static-1.12683",
  "crm_universal": "static-1.21722",
  "customer-data-email": "static-1.17733",
  "card-payment-highlight-lib": "static-1.36615",
  "card-subscription-highlight-lib": "static-1.38988",
  "commerce-contract-lib": "static-1.11333",
  "customer-data-content": "static-1.26936",
  "invoices-highlight-card-lib": "static-1.54149",
  "orders-highlight-card-lib": "static-1.20959",
  "products-highlight-card-lib": "static-1.17242",
  "project-storage": "static-1.4570",
  "quotes-highlight-card-lib": "static-1.71325",
  "crm-source-interpretation-lib": "static-1.5167",
  "utility-belt": "static-1.2377",
  "customer-data-associations": "static-1.7169",
  "framework-data-table": "static-2.11503",
  "payments-enrollment-embed-lib": "static-1.22126",
  "customer-data-rte": "static-1.32533",
  "cv-backend-services": "static-1.1514",
  "growth-onboarding-empty-states": "static-1.5423",
  "InboxConnectUtils": "static-4.14319",
  "payments-post-enroll-local-storage-lib": "static-1.4951",
  "qrcode-generator": "static-1.65",
  "quotes-client-types": "static-1.37414",
  "calling-orchestration-schema": "static-1.35132",
  "sales-views-client-types": "static-1.4123",
  "hub-http-contrib": "static-1.2880",
  "interframe": "static-3.4617",
  "tinymce-data": "static-1.39932",
  "ui-addon-sales-email": "static-1.5051",
  "layout-dnd-components": "static-1.12106",
  "layout-dnd-utils": "static-1.11081",
  "ui-brand-identity-lib": "static-1.14136",
  "NamespacedHubStyle": "static-2.8932",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4368",
  "video-embed": "static-1.35172",
  "social-insights-client-types": "static-1.21467",
  "sequences-lib": "static-1.7745",
  "ui-gdpr-components": "static-1.10184",
  "products-ui-components": "static-1.39477",
  "quotes-ui-lib": "static-1.80045",
  "SalesContentIndexUI": "static-3.8954",
  "accounting-integrations-ui-components": "static-1.6784",
  "invoices-ui-lib": "static-1.54165",
  "commerce-products-api": "static-1.2007",
  "SafeStorage": "static-1.4239",
  "invoices-iframe-lib": "static-1.56223",
  "quotes-modal-lib": "static-1.102002",
  "deal-intel-decorators": "static-1.1387",
  "tanstack-virtual": "static-1.26",
  "stripe-embedded-components": "static-1.7198",
  "draft-content-plugins": "static-1.27800",
  "ContentData": "static-1.67805",
  "layout-data-lib": "static-1.9406",
  "outpost": "static-1.4038",
  "sequences-client-types-lib": "static-1.7602",
  "commerce-tax-lib": "static-1.353",
  "property-description-translator": "static-1.3692",
  "FireAlarmUi": "static-1.4368",
  "sales-templates-service-types-lib": "static-1.4028",
  "commerce-analytics-service-client": "static-1.3492",
  "totals-ui-components": "static-1.23089",
  "deal-intel-utils": "static-1.1391",
  "stripe-connect-js": "static-1.65",
  "advanced-menus-core": "static-1.14872",
  "advanced-menus-lib": "static-1.11842",
  "ui-memberships-settings-lib": "static-1.33550",
  "commerce-totals-service-types": "static-1.3676",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14871",
  "simple-menus-lib": "static-1.16388"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11668",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.450",
  "dashboard-client-types": "/dashboard-client-types/static-1.258",
  "data-fetching-client": "/data-fetching-client/static-1.9514",
  "foundations-components": "/foundations-components/static-1.7595",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.620",
  "foundations-theming": "/foundations-theming/static-1.4247",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7843",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9562",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11278",
  "I18n": "/I18n/static-7.1580",
  "jasmine-runner": "/jasmine-runner/static-1.6306",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11728",
  "quartz": "/quartz/static-1.6780",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16487",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2700",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8606",
  "settings-ui-lib": "/settings-ui-lib/static-1.12360",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6800",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10981",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9382",
  "unified-auth": "/unified-auth/static-1.266",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.547",
  "usage-tracker": "/usage-tracker/static-1.7172",
  "usage-tracker-core": "/usage-tracker-core/static-1.7022",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7916",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6054",
  "integrations-lib": "/integrations-lib/static-1.15550",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19051",
  "property-management-iframe": "/property-management-iframe/static-1.12486",
  "quartz-config": "/quartz-config/static-1.558",
  "quartz-core": "/quartz-core/static-1.5999",
  "quartz-routing": "/quartz-routing/static-1.210",
  "quick-fetch": "/quick-fetch/static-1.3773",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4474",
  "ts-schema": "/ts-schema/static-1.3941",
  "ui-universal-auth": "/ui-universal-auth/static-1.8752",
  "UIComponents": "/UIComponents/static-3.8225",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3265",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3057",
  "quartz-webpack": "/quartz-webpack/static-1.3004",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3864",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4676",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1963",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9263",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5210",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1312",
  "ui-fonts": "/ui-fonts/static-1.540",
  "ui-images": "/ui-images/static-2.1106",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2730",
  "foundations-theming-base": "/foundations-theming-base/static-1.3232",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.718",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2954",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4163",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8454",
  "ai-rendering-library": "/ai-rendering-library/static-1.9416",
  "chirp-fetch": "/chirp-fetch/static-1.1719",
  "connections-embed-lib": "/connections-embed-lib/static-1.691",
  "copilot-toolkit": "/copilot-toolkit/static-1.10627",
  "laboratory-lib": "/laboratory-lib/static-3.6996",
  "marketplace-embed": "/marketplace-embed/static-1.21569",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8947",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19007",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13222",
  "sanitize-text": "/sanitize-text/static-1.7982",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8533",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5586",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4858",
  "wootric-nps": "/wootric-nps/static-1.6821",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4488",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3991",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66673",
  "cssUtils": "/cssUtils/static-1.744",
  "flux-actions": "/flux-actions/static-1.311",
  "HubStyle": "/HubStyle/static-2.11586",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10048",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10210",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7162",
  "icons": "/icons/static-2.626",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17584",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4357",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5078",
  "quartz-i18n": "/quartz-i18n/static-1.455",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3567",
  "customer-data-objects": "/customer-data-objects/static-1.7485",
  "property-translator": "/property-translator/static-1.5245",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7761",
  "hs-promise-utils": "/hs-promise-utils/static-1.5430",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4716",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12965",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5425",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7624",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4311",
  "superstore": "/superstore/static-1.4606",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9983",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7558",
  "hub-http-janus": "/hub-http-janus/static-1.803",
  "hubspotter-http": "/hubspotter-http/static-1.4514",
  "immutable-less": "/immutable-less/static-1.4491",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16458",
  "nav-meta": "/nav-meta/static-1.29036",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10077",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17707",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3710",
  "property-management-common": "/property-management-common/static-1.4773",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8884",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.491",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.455",
  "quartz-head": "/quartz-head/static-1.445",
  "quartz-test": "/quartz-test/static-1.455",
  "quartz-tracking": "/quartz-tracking/static-1.159",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2982",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20482",
  "ContentUtils": "/ContentUtils/static-1.67730",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2327",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39040",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12848",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12984",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13682",
  "ExportDialog": "/ExportDialog/static-6.10224",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40750",
  "reporting-snowflake": "/reporting-snowflake/static-1.55291",
  "reporting-ui-components": "/reporting-ui-components/static-2.63944",
  "reporting-visualizations": "/reporting-visualizations/static-1.58749",
  "ui-addon-teams": "/ui-addon-teams/static-1.21288",
  "magpie-lib": "/magpie-lib/static-1.5431",
  "magpie-types": "/magpie-types/static-1.4891",
  "simple-logging-lib": "/simple-logging-lib/static-1.2887",
  "navigation-components": "/navigation-components/static-1.17399",
  "ai-studio-lib": "/ai-studio-lib/static-1.11097",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10330",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7829",
  "ui-tool-access": "/ui-tool-access/static-1.9981",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8109",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5589",
  "usage-tracker-public": "/usage-tracker-public/static-1.6983",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3456",
  "persist-promise": "/persist-promise/static-1.3545",
  "reference-resolvers": "/reference-resolvers/static-1.7999",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3781",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.175",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2835",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2285",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4907",
  "purchase-motions-components": "/purchase-motions-components/static-1.5525",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1388",
  "crm-component-utils": "/crm-component-utils/static-1.38570",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5709",
  "customer-data-properties": "/customer-data-properties/static-1.50874",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6709",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7923",
  "navigation-messaging": "/navigation-messaging/static-1.6726",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9560",
  "cms-field-types": "/cms-field-types/static-1.4644",
  "content-icons-ui": "/content-icons-ui/static-1.2167",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7085",
  "crm-message-bus": "/crm-message-bus/static-1.42475",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21475",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9661",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4558",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3869",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6614",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.810",
  "onboarding-tours": "/onboarding-tours/static-1.16315",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13168",
  "academy-common-lib": "/academy-common-lib/static-1.13142",
  "content-assistance-lib": "/content-assistance-lib/static-1.7503",
  "dashboard-lib": "/dashboard-lib/static-1.80776",
  "file-manager-components": "/file-manager-components/static-1.23006",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17987",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17704",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17696",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19534",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8530",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4603",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10756",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8868",
  "user-context": "/user-context/static-1.4936",
  "growth-payments-core": "/growth-payments-core/static-1.24833",
  "reporting-plugins": "/reporting-plugins/static-1.10022",
  "reporting-reports": "/reporting-reports/static-1.66351",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.562",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28938",
  "react-codemirror": "/react-codemirror/static-1.10463",
  "apps-service-types": "/apps-service-types/static-1.3714",
  "oauth-service-types": "/oauth-service-types/static-1.4084",
  "onboarding-scopes": "/onboarding-scopes/static-1.6300",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4529",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7527",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14627",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3479",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8678",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4336",
  "nav-client-types": "/nav-client-types/static-1.2194",
  "purchase-motions-api": "/purchase-motions-api/static-1.5528",
  "signup-constants": "/signup-constants/static-1.18498",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7871",
  "trials-service-types": "/trials-service-types/static-1.3737",
  "card-properties-lib": "/card-properties-lib/static-1.43632",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36565",
  "crm-actions": "/crm-actions/static-1.6142",
  "crm-cards-data": "/crm-cards-data/static-1.1295",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43033",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8889",
  "customer-data-tracking": "/customer-data-tracking/static-1.6719",
  "calling-global-api": "/calling-global-api/static-1.63803",
  "calling-internal-common": "/calling-internal-common/static-1.31132",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65185",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57479",
  "commerce-products-lib": "/commerce-products-lib/static-1.8958",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3659",
  "crm-links": "/crm-links/static-1.6103",
  "external-options-client-types": "/external-options-client-types/static-1.4020",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.517",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4083",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.469",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3552",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48124",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3825",
  "property-value-citations": "/property-value-citations/static-1.1488",
  "pulse": "/pulse/static-1.353",
  "smart-property-lib": "/smart-property-lib/static-1.6084",
  "tiered-pricing": "/tiered-pricing/static-1.881",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10830",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4001",
  "react-dnd-compat": "/react-dnd-compat/static-1.4457",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5195",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2909",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1392",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.381",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7364",
  "academy-service-client": "/academy-service-client/static-1.3517",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28044",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8222",
  "video-components-external": "/video-components-external/static-1.10680",
  "video-data-lib": "/video-data-lib/static-1.34338",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8404",
  "payment-link-components": "/payment-link-components/static-1.23040",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9724",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23979",
  "viral-links-lib": "/viral-links-lib/static-1.6875",
  "data-token-picker": "/data-token-picker/static-1.16106",
  "FileManagerLib": "/FileManagerLib/static-1.38646",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5081",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17105",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8396",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.229",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3018",
  "crm_data": "/crm_data/static-4.91365",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45515",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15202",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18597",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18045",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9888",
  "crm-fe-perf": "/crm-fe-perf/static-1.22742",
  "calling-error-reporting": "/calling-error-reporting/static-1.31138",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10876",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6378",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.355",
  "commerce-permissions": "/commerce-permissions/static-1.598",
  "products-iframe-lib": "/products-iframe-lib/static-1.7430",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9944",
  "directed-graph": "/directed-graph/static-1.776",
  "event-emitter": "/event-emitter/static-1.784",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5376",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9645",
  "policy-lib": "/policy-lib/static-1.6614",
  "react-tinymce": "/react-tinymce/static-1.54721",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9708",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53847",
  "tinymce-plugins": "/tinymce-plugins/static-1.56961",
  "tinymce-themes": "/tinymce-themes/static-1.55817",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1420",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6418",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11586",
  "content-media-compositions": "/content-media-compositions/static-2.15593",
  "media-bridge-lib": "/media-bridge-lib/static-1.18628",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5771",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4923",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3504",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21371",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3680",
  "audio-components": "/audio-components/static-1.5666",
  "FileManagerCore": "/FileManagerCore/static-1.38505",
  "FileManagerImages": "/FileManagerImages/static-1.36157",
  "video-components": "/video-components/static-1.12683",
  "crm_universal": "/crm_universal/static-1.21722",
  "customer-data-email": "/customer-data-email/static-1.17733",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36615",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38988",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11333",
  "customer-data-content": "/customer-data-content/static-1.26936",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54149",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20959",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17242",
  "project-storage": "/project-storage/static-1.4570",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71325",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5167",
  "utility-belt": "/utility-belt/static-1.2377",
  "customer-data-associations": "/customer-data-associations/static-1.7169",
  "framework-data-table": "/framework-data-table/static-2.11503",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22126",
  "customer-data-rte": "/customer-data-rte/static-1.32533",
  "cv-backend-services": "/cv-backend-services/static-1.1514",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5423",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14319",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4951",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "quotes-client-types": "/quotes-client-types/static-1.37414",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35132",
  "sales-views-client-types": "/sales-views-client-types/static-1.4123",
  "hub-http-contrib": "/hub-http-contrib/static-1.2880",
  "interframe": "/interframe/static-3.4617",
  "tinymce-data": "/tinymce-data/static-1.39932",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5051",
  "layout-dnd-components": "/layout-dnd-components/static-1.12106",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11081",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14136",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8932",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4368",
  "video-embed": "/video-embed/static-1.35172",
  "social-insights-client-types": "/social-insights-client-types/static-1.21467",
  "sequences-lib": "/sequences-lib/static-1.7745",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10184",
  "products-ui-components": "/products-ui-components/static-1.39477",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80045",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8954",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6784",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54165",
  "commerce-products-api": "/commerce-products-api/static-1.2007",
  "SafeStorage": "/SafeStorage/static-1.4239",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56223",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102002",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1387",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7198",
  "draft-content-plugins": "/draft-content-plugins/static-1.27800",
  "ContentData": "/ContentData/static-1.67805",
  "layout-data-lib": "/layout-data-lib/static-1.9406",
  "outpost": "/outpost/static-1.4038",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7602",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.353",
  "property-description-translator": "/property-description-translator/static-1.3692",
  "FireAlarmUi": "/FireAlarmUi/static-1.4368",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4028",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3492",
  "totals-ui-components": "/totals-ui-components/static-1.23089",
  "deal-intel-utils": "/deal-intel-utils/static-1.1391",
  "stripe-connect-js": "/stripe-connect-js/static-1.65",
  "advanced-menus-core": "/advanced-menus-core/static-1.14872",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11842",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33550",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3676",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14871",
  "simple-menus-lib": "/simple-menus-lib/static-1.16388"
}
};
